import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import FieldPreviewNaked from '../FieldPreviewNaked';
var colorMap = {
  default: 'action',
  error: 'error',
  inherit: 'inherit',
  primary: 'primary',
  secondary: 'secondary',
  textPrimary: 'disabled',
  textSecondary: 'disabled'
};
/**
 * Preview boolean hodnoty.
 */

function CheckboxFieldPreviewNaked(_ref) {
  var color = _ref.color,
      label = _ref.label,
      size = _ref.size,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["color", "label", "size", "value"]);

  var Component = value ? CheckBoxIcon : CheckBoxOutlineIcon;
  return /*#__PURE__*/React.createElement(FieldPreviewNaked, _extends({}, rest, {
    size: size,
    color: color,
    value: /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'inline-flex'
      }
    }, /*#__PURE__*/React.createElement(Component, {
      color: colorMap[color] || colorMap.default,
      fontSize: size
    }), label && /*#__PURE__*/React.createElement("span", {
      style: {
        paddingLeft: '0.2em'
      }
    }, label))
  }));
}

CheckboxFieldPreviewNaked.propTypes = {
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  className: PropTypes.string,

  /**
   * Barva zobrazovane hodnoty.
   */
  color: PropTypes.oneOf(['initial', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * `true` pokud se ma komponenta zobrazit v cele dostupne sirce.
   */
  fullWidth: PropTypes.bool,

  /**
   * Custom vlastnosti `Input`.
   */
  InputProps: PropTypes.shape({}),
  label: PropTypes.string,
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  noWrap: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'default', 'large', 'inherit']),
  style: PropTypes.shape({}),
  value: PropTypes.bool
};
CheckboxFieldPreviewNaked.defaultProps = {
  align: undefined,
  className: undefined,
  color: undefined,
  display: undefined,
  fullWidth: false,
  InputProps: undefined,
  label: undefined,
  margin: undefined,
  noWrap: false,
  size: undefined,
  style: undefined,
  value: false
};
export default CheckboxFieldPreviewNaked;